import get from "lodash/get";

export const getUsers = state => state?.users.items;

export const userSelector = (state, user) =>
  getUsers(state)[get(user, "id", user)];

export const getUserById = doctorId => state => state.users.items[doctorId];
